export default __webpack_public_path__ + "static/media/error404.fc69886e.gif";